var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1641 5.8125C14.5391 6.14062 14.75 6.60938 14.7266 7.07812C14.7266 7.57031 14.4922 8.01562 14.0938 8.29688L11.75 10.0781C11.375 10.3594 10.9062 10.5 10.4375 10.5H1.625C1.41406 10.5 1.25 10.3359 1.25 10.125V9.75C1.25 9.5625 1.41406 9.375 1.625 9.375H10.4375C10.6719 9.375 10.8828 9.30469 11.0703 9.16406L13.4375 7.40625C13.6719 7.21875 13.6953 6.89062 13.4375 6.67969C13.2734 6.53906 12.9688 6.53906 12.7812 6.67969L11.3516 7.75781C11.1641 7.89844 10.9531 7.96875 10.7188 7.96875H7.55469C7.39062 7.96875 7.25 7.82812 7.25 7.66406V7.64062C7.25 7.47656 7.39062 7.33594 7.55469 7.33594H8.96094C9.66406 7.33594 9.64062 6.375 8.98438 6.375H5.60938C5.1875 6.375 4.78906 6.51562 4.46094 6.77344L3.5 7.5H1.625C1.41406 7.5 1.25 7.33594 1.25 7.125V6.75C1.25 6.5625 1.41406 6.375 1.625 6.375H3.10156L3.78125 5.88281C4.29688 5.48438 4.95312 5.25 5.60938 5.25H8.98438C9.89844 5.25 10.6016 5.95312 10.6016 6.84375H10.6953L12.1016 5.78906C12.5469 5.4375 13.4375 5.20312 14.1641 5.8125Z",
    fill: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferIcon);
export default __webpack_public_path__ + "static/media/offerIcon.86cff11ce3810fb922babdfecae81272.svg";
export { ForwardRef as ReactComponent };